var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 159.09,
    height: 140,
    viewBox: "0 0 159.09 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: rgba(27,27,27,0);\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n\r\n      .cls-3 {\r\n        opacity: 0.6;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: url(#linear-gradient-2);\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: url(#linear-gradient-3);\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: url(#linear-gradient-4);\r\n      }\r\n\r\n      .cls-7 {\r\n        fill: #e8e8e8;\r\n      }\r\n\r\n      .cls-8 {\r\n        fill: #d2d2d2;\r\n      }\r\n\r\n      .cls-9 {\r\n        fill: #e7e7e7;\r\n      }\r\n\r\n      .cls-10 {\r\n        fill: #c9c9c9;\r\n      }\r\n\r\n      .cls-11 {\r\n        fill: #dcdcdc;\r\n      }\r\n\r\n      .cls-12 {\r\n        fill: #d0d0d0;\r\n      }\r\n\r\n      .cls-13 {\r\n        fill: #e2e2e2;\r\n      }\r\n\r\n      .cls-14 {\r\n        fill: #f1f1f1;\r\n      }\r\n\r\n      .cls-15 {\r\n        fill: #ffdfba;\r\n      }\r\n\r\n      .cls-16 {\r\n        fill: #ffe0bc;\r\n      }\r\n\r\n      .cls-17 {\r\n        fill: #5f5f5f;\r\n      }\r\n\r\n      .cls-18 {\r\n        fill: #0b0b0b;\r\n      }\r\n\r\n      .cls-19 {\r\n        fill: #7ac5ff;\r\n      }\r\n\r\n      .cls-20 {\r\n        fill: #ffecd6;\r\n      }\r\n\r\n      .cls-21 {\r\n        fill: #161616;\r\n      }\r\n\r\n      .cls-22 {\r\n        fill: #999;\r\n        font-size: 14px;\r\n        font-family: MicrosoftYaHeiUI, Microsoft YaHei UI;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1.25,
    x2: 0.5,
    y2: -0.25,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#f7f7f7",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#efefef"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.875,
    y1: 133.719,
    x2: 0.875,
    y2: -205.781,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#efefef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#efefef"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1.746,
    y1: 96.138,
    x2: 1.746,
    y2: -142.698,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 3.374,
    y1: 109.054,
    x2: 3.374,
    y2: -166.875,
    xlinkHref: "#linear-gradient-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u63D2\\u753B_\\u6682\\u65E0\\u6570\\u636E",
    transform: "translate(-713.069 -1569)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u65E0\\u641C\\u7D22\\u7ED3\\u679C_\\u6362\\u4E2A\\u8BCD\\u8BD5\\u8BD5\\u5427_",
    "data-name": "\\u65E0\\u641C\\u7D22\\u7ED3\\u679C\\uFF0C\\u6362\\u4E2A\\u8BCD\\u8BD5\\u8BD5\\u5427~",
    transform: "translate(375.069 -2380)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u692D\\u5706_1",
    "data-name": "\\u692D\\u5706 1",
    transform: "translate(338 4016.497)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u692D\\u5706_1-2",
    "data-name": "\\u692D\\u5706 1",
    className: "cls-1",
    cx: 79.545,
    cy: 36.251,
    rx: 79.545,
    ry: 36.251,
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Gradient_Overlay",
    "data-name": "Gradient Overlay",
    className: "cls-2",
    d: "M79.545,0c43.931,0,79.545,16.23,79.545,36.251S123.476,72.5,79.545,72.5,0,56.272,0,36.251,35.614,0,79.545,0Z",
    transform: "translate(0)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u4E91-3",
    className: "cls-3",
    transform: "translate(444.145 3991.074)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u4E91-3-2",
    "data-name": "\\u4E91-3",
    className: "cls-1",
    d: "M4.64,14.318a4.7,4.7,0,0,1,0-9.408q.126,0,.251.007a6.658,6.658,0,0,1,12.932.321,4.553,4.553,0,0,1,1.7-.328,4.706,4.706,0,0,1,.2,9.4v0Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Gradient_Overlay-2",
    "data-name": "Gradient Overlay",
    className: "cls-4",
    d: "M4.64,14.318a4.7,4.7,0,0,1,0-9.408q.126,0,.251.007a6.658,6.658,0,0,1,12.932.321,4.553,4.553,0,0,1,1.7-.328,4.706,4.706,0,0,1,.2,9.4v0Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u4E91-2",
    className: "cls-3",
    transform: "translate(405.051 3949)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u4E91-2-2",
    "data-name": "\\u4E91-2",
    className: "cls-1",
    d: "M27.607,20.348H6.883c-.088,0-.177.005-.265.005a6.687,6.687,0,0,1,0-13.374q.185,0,.368.01a9.488,9.488,0,0,1,18.422.47,6.534,6.534,0,0,1,2.465-.48,6.689,6.689,0,0,1,.265,13.369h0c-.088,0-.176.005-.265.005S27.7,20.351,27.607,20.348Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Gradient_Overlay-3",
    "data-name": "Gradient Overlay",
    className: "cls-5",
    d: "M27.607,20.348H6.883c-.088,0-.177.005-.265.005a6.687,6.687,0,0,1,0-13.374q.185,0,.368.01a9.488,9.488,0,0,1,18.422.47,6.534,6.534,0,0,1,2.465-.48,6.689,6.689,0,0,1,.265,13.369h0c-.088,0-.176.005-.265.005S27.7,20.351,27.607,20.348Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u4E91-1",
    className: "cls-3",
    transform: "translate(363.508 3984.482)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u4E91-1-2",
    "data-name": "\\u4E91-1",
    className: "cls-1",
    d: "M5.8,17.617h0a5.8,5.8,0,0,1,0-11.6q.163,0,.324.009a8.326,8.326,0,0,1,16.107.4,5.8,5.8,0,1,1,2.384,11.187v0Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Gradient_Overlay-4",
    "data-name": "Gradient Overlay",
    className: "cls-6",
    d: "M5.8,17.617h0a5.8,5.8,0,0,1,0-11.6q.163,0,.324.009a8.326,8.326,0,0,1,16.107.4,5.8,5.8,0,1,1,2.384,11.187v0Z",
    transform: "translate(0)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u653E\\u5927\\u955C\\u6295\\u5F71",
    className: "cls-7",
    cx: 4.948,
    cy: 1.177,
    rx: 4.948,
    ry: 1.177,
    transform: "translate(429.376 4037.926)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u4EBA\\u6295\\u5F71",
    className: "cls-7",
    cx: 2.927,
    cy: 1.183,
    rx: 2.927,
    ry: 1.183,
    transform: "translate(395.633 4037.332)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u6811-3",
    transform: "translate(468.425 4024.834)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u5706\\u89D2\\u77E9\\u5F62_1_\\u62F7\\u8D1D_2",
    "data-name": "\\u5706\\u89D2\\u77E9\\u5F62 1 \\u62F7\\u8D1D 2",
    className: "cls-8",
    width: 0.78,
    height: 3.945,
    rx: 0.39,
    transform: "translate(2.314 6.277)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u5F62\\u72B6_1_\\u62F7\\u8D1D",
    "data-name": "\\u5F62\\u72B6 1 \\u62F7\\u8D1D",
    className: "cls-9",
    d: "M586.439,4092c-2.96,3.16-3.67,7.2,0,7.334C590.092,4099.472,590.1,4094.558,586.439,4092Z",
    transform: "translate(-583.945 -4092.003)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u6811-2",
    transform: "translate(452.25 4014.422)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u5706\\u89D2\\u77E9\\u5F62_1_\\u62F7\\u8D1D",
    "data-name": "\\u5706\\u89D2\\u77E9\\u5F62 1 \\u62F7\\u8D1D",
    className: "cls-8",
    width: 0.96,
    height: 6.263,
    rx: 0.48,
    transform: "translate(2.978 7.675)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u5F62\\u72B6_1",
    "data-name": "\\u5F62\\u72B6 1",
    className: "cls-9",
    d: "M556.618,4072.367c-3.769,4.063-4.673,9.257,0,9.43C561.269,4081.97,561.28,4075.652,556.618,4072.367Z",
    transform: "translate(-553.443 -4072.367)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u6811-1",
    transform: "translate(365.587 4009.471)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u5706\\u89D2\\u77E9\\u5F62_1",
    "data-name": "\\u5706\\u89D2\\u77E9\\u5F62 1",
    className: "cls-8",
    width: 1.358,
    height: 7.276,
    rx: 0.679,
    transform: "translate(4.082 12.774)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u5F62\\u72B6_1_\\u62F7\\u8D1D_2",
    "data-name": "\\u5F62\\u72B6 1 \\u62F7\\u8D1D 2",
    className: "cls-9",
    d: "M394.542,4063.031c-5.366,5.755-6.653,13.114,0,13.36C401.164,4076.635,401.179,4067.686,394.542,4063.031Z",
    transform: "translate(-390.022 -4063.031)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u653E\\u5927\\u955C",
    transform: "translate(399.146 3983.205)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u5F62\\u72B6_53",
    "data-name": "\\u5F62\\u72B6 53",
    className: "cls-10",
    d: "M497.108,4069.626l2.91,5.108a1.514,1.514,0,0,1,1.358.589c.652.735,9.7,16.9,9.7,16.9s.417.829-.194,1.179c-.409.234-2.716,1.768-2.716,1.768s-.435.267-.88-.309c-.432-.56-9.788-16.977-9.791-16.979s-.587-1.194,0-1.768c-.48-.738-2.91-4.911-2.91-4.911Z",
    transform: "translate(-472.694 -4039.862)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u5F62\\u72B6_53-2",
    "data-name": "\\u5F62\\u72B6 53",
    className: "cls-11",
    d: "M493.6,4071.849l2.91,5.108a1.515,1.515,0,0,1,1.358.589c.652.736,9.895,17.093,9.895,17.093s.417.828-.194,1.179c-.409.236-2.328,1.375-2.328,1.375s-.435.267-.88-.31c-.432-.56-9.788-17.173-9.791-17.176s-.587-1.194,0-1.768c-.48-.738-2.91-4.912-2.91-4.912Z",
    transform: "translate(-471.319 -4040.906)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u692D\\u5706_10",
    "data-name": "\\u692D\\u5706 10",
    className: "cls-12",
    d: "M456.731,4021.627c4.481-2.529,11.646,1.839,16,9.756s4.258,16.385-.223,18.914-11.646-1.839-16-9.755S452.25,4024.157,456.731,4021.627Z",
    transform: "translate(-453.304 -4016.98)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u5F62\\u72B6_52",
    "data-name": "\\u5F62\\u72B6 52",
    className: "cls-12",
    d: "M11.829,26.6A25.863,25.863,0,0,1,6.34,19.632a26.08,26.08,0,0,1-2.982-8.494L0,5.009,6.791.49l.047.082c4.494-2.206,11.459,2.144,15.729,9.9,4.116,7.477,4.255,15.445.484,18.439l.037.065-7.373,4.715Z",
    transform: "translate(2.878 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u692D\\u5706_10-2",
    "data-name": "\\u692D\\u5706 10",
    className: "cls-13",
    d: "M456.731,4021.627c4.481-2.529,11.646,1.839,16,9.756s4.258,16.385-.223,18.914-11.646-1.839-16-9.755S452.25,4024.157,456.731,4021.627Z",
    transform: "translate(-453.304 -4016.98)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u692D\\u5706_10-3",
    "data-name": "\\u692D\\u5706 10",
    className: "cls-14",
    d: "M460.587,4029.043c3.379-1.9,8.783,1.38,12.069,7.321s3.211,12.3-.168,14.193-8.783-1.38-12.069-7.321S457.207,4030.941,460.587,4029.043Z",
    transform: "translate(-455.511 -4020.548)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u4EBA",
    transform: "translate(391.548 4014.344)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u5F62\\u72B6_39",
    "data-name": "\\u5F62\\u72B6 39",
    className: "cls-15",
    d: "M451.654,4078.213a1.381,1.381,0,0,0-.389.789c-.018.2-.761.162-.973,0s-.01-.965,0-1.183.778-.2.778-.2S451.921,4077.924,451.654,4078.213Z",
    transform: "translate(-444.246 -4074.758)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u5F62\\u72B6_41",
    "data-name": "\\u5F62\\u72B6 41",
    className: "cls-16",
    d: "M442.492,4082.354c-.212.148-.344.387-.584,0s-.9-1.669-1.557-1.775a1.668,1.668,0,0,0-1.362.395c-.1.148.49.246.779.2a.707.707,0,0,1,.778.591c.149.487.824,2.416,1.946,1.972s.779-.592.779-.592S442.7,4082.206,442.492,4082.354Z",
    transform: "translate(-438.978 -4076.137)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u5F62\\u72B6_42",
    "data-name": "\\u5F62\\u72B6 42",
    className: "cls-16",
    d: "M456.488,4083.086c.316.374.324.387.584.2s1.491-1.7,1.946-1.577,1.479.193.973.592c-.3.233-1.095-.121-1.168.394s-1.762,3.063-2.336,2.366a11.864,11.864,0,0,1-.973-1.38S456.172,4082.713,456.488,4083.086Z",
    transform: "translate(-446.745 -4076.672)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u5F62\\u72B6_43",
    "data-name": "\\u5F62\\u72B6 43",
    className: "cls-17",
    d: "M452.8,4095.2c-.018.853.3,5.119-.195,6.507a18.8,18.8,0,0,1-1.168,3.154c-.24.178-.789.388-.779-.394a17.207,17.207,0,0,1,.779-3.55,17.892,17.892,0,0,0-.389-3.549c-.574,1.022-.151,3.356-.389,3.943-.323.8-.233,3.6-.584,4.141s-.956.472-.973,0a45.442,45.442,0,0,0-.389-5.126,25.643,25.643,0,0,1-.195-4.535C448.583,4095.547,452.817,4094.35,452.8,4095.2Z",
    transform: "translate(-443.446 -4082.873)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u5F62\\u72B6_44",
    "data-name": "\\u5F62\\u72B6 44",
    className: "cls-18",
    d: "M451.979,4113.665c.233.063.3.105.584.4s1.985,1.677,1.168,1.971c-.49.176-1.122-.261-1.557-.591s-1.122-.937-.779-1.38S451.747,4113.6,451.979,4113.665Z",
    transform: "translate(-444.766 -4091.673)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u5F62\\u72B6_45",
    "data-name": "\\u5F62\\u72B6 45",
    className: "cls-18",
    d: "M450.215,4117.241c.622.29,1.575.274,1.168-.2s-1.011-1.189-1.168-1.38-.955.162-.973-.2-.65.416-.389.79A3.386,3.386,0,0,0,450.215,4117.241Z",
    transform: "translate(-443.587 -4092.489)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u5F62\\u72B6_40",
    "data-name": "\\u5F62\\u72B6 40",
    className: "cls-19",
    d: "M449.443,4080a1.89,1.89,0,0,1-1.752-.2c-.243-.254-1.679.386-1.752.591s-1.178,1.6-.779,1.775a1.328,1.328,0,0,1,.779.789l.584-.2s-.924,3.362-.389,4.929c.177.937.351.894.779.986s3.952.281,4.476-.591c.233-.387.351-.514,0-1.38a28.223,28.223,0,0,1-.973-3.746c-.018-.274,1.463-.571,1.362-.986S449.739,4079.851,449.443,4080Z",
    transform: "translate(-441.841 -4075.754)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u5F62\\u72B6_37",
    "data-name": "\\u5F62\\u72B6 37",
    className: "cls-20",
    d: "M452.478,4074.266c-.118.4-.349.747-.195.986s.273.511,0,.592-.155.748-.389.789a2.255,2.255,0,0,1-1.362-.789c-.39-.472-.287-.814.195-.986a1.1,1.1,0,0,1,.779-.986C451.793,4073.772,452.6,4073.87,452.478,4074.266Z",
    transform: "translate(-444.292 -4072.979)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u5F62\\u72B6_38",
    "data-name": "\\u5F62\\u72B6 38",
    className: "cls-21",
    d: "M452.248,4073.507c-.134.129-.65-.176-.779-.395s-.956.218-.973.592-.177.584-.389.592-.2.331,0,.394-.049.542-.389.591c-.24.036-.491-1.6-.195-2.169a1.366,1.366,0,0,1,1.752-.789C452.119,4072.669,452.46,4073.3,452.248,4073.507Z",
    transform: "translate(-443.868 -4072.22)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.908b0e96529eb033fb9a112ce0c5c5ce.svg";
export { ForwardRef as ReactComponent };